import { Auth0ContextInterface } from "@auth0/auth0-react";
import { request } from "util/methods";
import { RequestType } from "./request-type";

export enum CustomFieldDomainKey {
  CUSTOMER = "customer",
  MERCHANT = "merchant",
  AGENT = "agent",
  BOOKING = "booking",
  VEHICLE = "vehicle",
  REVIEW = "review",
  PAYMENT = "payment",
}

class CustomFieldService {
  public static async getCustomFieldsForGroup(
    { getAccessTokenSilently }: Auth0ContextInterface,
    groupId: string
  ): Promise<{
    [key in CustomFieldDomainKey]: string[];
  }> {
    const accessToken = await getAccessTokenSilently();

    const data = await request(
      RequestType.GET,
      accessToken,
      `/merchant-groups/${groupId}/custom-fields`
    );

    return data.data as {
      [key in CustomFieldDomainKey]: string[];
    };
  }
}

export default CustomFieldService;
